import React from 'react'
import { BarChart, Bar, XAxis, YAxis, LabelList, ResponsiveContainer } from 'recharts';
import {cleanTitle} from './AqUtilities';

export default function AqChoice({ question, data }) {

    const colors = ["#5A9BD4", "#FAA75B", "#9E67AB", "#CE7058", "#D77FB4","#F15A60","#7AC36A","#ACC906","#C64C1B","#82CA9D"]

    let nonZeroCount = 0;
    const shapedData = question.choices.map((item)=>{        
        const value = data[item.value]||0
        const fill = colors[nonZeroCount];
        nonZeroCount += (value?1:0)
        return {fill,value, title:item.text}        
    });
    
    const total = shapedData.reduce((accumulator, row) => accumulator + row.value, 0);

    return (
                
        <div className="aq-choice-question" >
            <h5>{cleanTitle(question.title)}</h5>
        <ResponsiveContainer width="80%" height={(question.choices.length + 1) * 30}> 
            <BarChart  data={shapedData} layout="vertical">                
                <XAxis type="number" hide axisLine={false} padding={{ right: 40 }} />
                <YAxis type="category" dataKey="title" dx={-10} tickLine={false} axisLine={false} width={250} />

                <Bar dataKey="value" isAnimationActive={false}>
                    <LabelList dataKey="value" position={ "right"} style={{ fill: "black" }} />
                </Bar>                
            </BarChart>
            </ResponsiveContainer>
            <div id="aq-bar-total">Total = <span id="aq-bar-total-number">{total}</span></div>
        </div>
    )
}
